// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".glide__bullet[data-v-72294610]{--tw-bg-opacity:1;background-color:rgb(115 102 121 / var(--tw-bg-opacity));width:10px;height:10px;border-radius:50px}.glide__bullet--active[data-v-72294610]{--tw-bg-opacity:1;background-color:rgb(50 32 59 / var(--tw-bg-opacity))}.surtitle[data-v-72294610]{font-weight:800;font-size:12px;line-height:16px;letter-spacing:.08em;text-transform:uppercase;color:#ff4235;margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
